import { memo } from 'react';
import { useTranslation } from 'react-i18next';

import { Balance } from '../../../models/Base';
import { Profile } from '../../../models/UserStore';
import { AvatarNode, PngIcon } from '../../Molecules';

import './GameStartVSBoard.css';

export type GameStartVSBoardProps = {
  profile: Profile;
  opponentRecords: Profile[];
  withAIBadge: boolean | undefined;
  reward?: Balance;
};

export const GameStartVSBoard = memo(
  ({
    profile,
    opponentRecords,
    withAIBadge,
    reward,
  }: GameStartVSBoardProps) => {
    const { t } = useTranslation();
    return (
      <div className="vs-board">
        {profile ? (
          <div className="vs-row">
            <AvatarNode profile={profile} size={75} />
            {opponentRecords.length > 0 ? <p className="vs-text">VS</p> : null}
            {opponentRecords.map((opponent) => (
              // <>TODO: AvatarNode + AI label if is dummy record</>
              <div key={opponent.userId} className={'opponent'}>
                <AvatarNode profile={opponent} size={75} />
                {withAIBadge && (
                  <div className="ai-badge">
                    <span className="ai-badge-label">AI</span>
                  </div>
                )}
              </div>
            ))}
          </div>
        ) : null}
        {reward && !reward.isEmpty && reward.breadSlice > 0 ? (
          <div className="rewards-row">
            {reward.breadSlice > 0 && (
              <div className="reward-node">
                <PngIcon name="Bread" className="reward-icon" />
                <p className="reward-text">{reward.breadSlice}</p>
              </div>
            )}
            {/* {reward.exp > 0 && (
              <div className="reward-node">
                <PngIcon name={'KnowledgeXP'} className="reward-icon" />
                <p className="reward-text">x{reward.exp}</p>
              </div>
            )} */}
          </div>
        ) : null}
        {opponentRecords.length > 0 && (
          <p className="reward-description">
            {t("Defeat your opponent to earn the winner's rewards!")}
          </p>
        )}
      </div>
    );
  },
);
